export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11131.ee0553f4.jpg";